import { render, staticRenderFns } from "./PageGotoLogin.vue?vue&type=template&id=f6ad3b14&scoped=true&lang=html&"
import script from "./PageGotoLogin.vue?vue&type=script&lang=js&"
export * from "./PageGotoLogin.vue?vue&type=script&lang=js&"
import style0 from "./PageGotoLogin.vue?vue&type=style&index=0&id=f6ad3b14&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ad3b14",
  null
  
)

export default component.exports